module.exports = __webpack_public_path__ + "img/still (21).9b0d8242.jpg";